import type { SavedTrack } from '@kangaroo/shared';

export function findNearestTrack(tracks: SavedTrack[], centerLat: number, centerLon: number, maxDistanceKm = 2) {
  let closest: SavedTrack | null = null;
  let closestDistance = Number.POSITIVE_INFINITY;

  for (const track of tracks) {
    const distance = haversineKm(centerLat, centerLon, track.centerLat, track.centerLon);
    if (distance < closestDistance) {
      closest = track;
      closestDistance = distance;
    }
  }

  return closestDistance <= maxDistanceKm ? closest : null;
}

export function findTrackByName(tracks: SavedTrack[], name: string) {
  return findTrackByVenue(tracks, name);
}

export function venuesAlign(venue: string, trackName: string) {
  const normalizedVenue = venue.trim().toLowerCase();
  const normalizedTrack = trackName.trim().toLowerCase();
  if (!normalizedVenue || !normalizedTrack) {
    return false;
  }

  if (normalizedVenue === normalizedTrack) {
    return true;
  }

  const shorter = normalizedVenue.length <= normalizedTrack.length ? normalizedVenue : normalizedTrack;
  const longer = normalizedVenue.length > normalizedTrack.length ? normalizedVenue : normalizedTrack;
  if (shorter.length < 4) {
    return false;
  }

  return longer.includes(shorter);
}

export function findTrackByVenue(tracks: SavedTrack[], venue: string) {
  const normalized = venue.trim().toLowerCase();
  if (!normalized) {
    return null;
  }

  const exact = tracks.find((track) => track.name.trim().toLowerCase() === normalized);
  if (exact) {
    return exact;
  }

  return (
    tracks.find((track) => {
      const name = track.name.trim().toLowerCase();
      return venuesAlign(normalized, name);
    }) ?? null
  );
}

export function trackDistanceKm(track: SavedTrack, centerLat: number, centerLon: number) {
  return haversineKm(centerLat, centerLon, track.centerLat, track.centerLon);
}

function haversineKm(lat1: number, lon1: number, lat2: number, lon2: number) {
  const toRad = (value: number) => (value * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

  return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
